module.exports = __webpack_public_path__ + "static/media/09n.b327616e.png";